import { render, staticRenderFns } from "./MainProcessForm.vue?vue&type=template&id=ab542c46&"
import script from "./MainProcessForm.vue?vue&type=script&lang=js&"
export * from "./MainProcessForm.vue?vue&type=script&lang=js&"
import style0 from "./MainProcessForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports